export default __webpack_public_path__ + "static/media/emerald-2.4231c480.png";